export const MORE_GUIDE_SLUG =
  'learn-more-about-the-experts-behind-our-helpful-guides';
